'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _BasketProductDetail = require('../../default/BasketProductDetail');

var _BasketProductDetail2 = _interopRequireDefault(_BasketProductDetail);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AddToBasketView: {
        displayName: 'AddToBasketView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/default/AddToBasketView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AddToBasketView = _wrapComponent('AddToBasketView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AddToBasketView, _Component);

    function AddToBasketView() {
        (0, _classCallCheck3.default)(this, AddToBasketView);
        return (0, _possibleConstructorReturn3.default)(this, (AddToBasketView.__proto__ || (0, _getPrototypeOf2.default)(AddToBasketView)).apply(this, arguments));
    }

    (0, _createClass3.default)(AddToBasketView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                callback = _props.callback,
                callbackOneClick = _props.callbackOneClick,
                product = _props.product,
                lang = _props.lang,
                count = _props.count,
                customFields = _props.customFields,
                changeCustomFields = _props.changeCustomFields,
                props = (0, _objectWithoutProperties3.default)(_props, ['className', 'callback', 'callbackOneClick', 'product', 'lang', 'count', 'customFields', 'changeCustomFields']),
                storable = product.storable,
                _product$remainder = product.remainder,
                remainder = _product$remainder === undefined ? [] : _product$remainder;

            if (count === undefined || count === null) {
                count = 1;
            }
            if (!className) {
                className = [];
            }

            className = [].concat((0, _toConsumableArray3.default)(className), ['le-button']);

            var addBasketButtonName = this.props.addBasketButtonName;
            var addBasketButtonOneClickName = this.props.addBasketButtonOneClickName;
            var buttonSettings = product.additional_info ? JSON.parse(product.additional_info) : null;
            if (buttonSettings !== null && buttonSettings.cartButtonSettings !== undefined && buttonSettings.cartButtonSettings !== null) {
                if (buttonSettings.cartButtonSettings.isCustomCartButton === true) {
                    addBasketButtonName = buttonSettings.cartButtonSettings.buttonName;
                    addBasketButtonOneClickName = buttonSettings.cartButtonSettings.buttonOneClickName;
                }
            }
            var customFieldsView = null;
            if (customFields) {
                customFieldsView = _react3.default.createElement(
                    'div',
                    null,
                    customFields.map(function (item, i) {
                        return _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            null,
                            _react3.default.createElement(
                                _reactBootstrap.ControlLabel,
                                null,
                                item.name
                            ),
                            _react3.default.createElement('input', {
                                id: i,
                                value: item.value,
                                className: 'form-control',
                                placeholder: item.hint,
                                type: 'text',
                                onChange: changeCustomFields
                            })
                        );
                    })
                );
            }

            var productOutOfStock = lang['store.add_to_cart.product_out_of_stock'];

            if (product.modifier_option_id && product.modifier_option.storable && product.modifier_option.storage_strict && (product.modifier_option.remainder[0] && product.modifier_option.remainder[0].quantity <= 0 || product.modifier_option.remainder.length === 0)) {
                return _react3.default.createElement(
                    'div',
                    { id: 'noProductInStore', className: 'inline text-theme' },
                    productOutOfStock
                );
            } else if (product.modifiedOption.length > 0 && (product.modifier_option_id === null || product.modifier_option_id === undefined)) {
                var noProductInStore = true;
                if (product.type_id !== 5) {
                    product.modifiedOption.forEach(function (item) {
                        if (!(item.storable && item.storage_strict && (item.remainder[0] && item.remainder[0].quantity <= 0 || item.remainder.length === 0))) {
                            noProductInStore = false;
                        }
                    });
                } else {
                    if (storable && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
                        noProductInStore = true;
                    } else {
                        noProductInStore = false;
                    }
                }
                if (noProductInStore) {
                    return _react3.default.createElement(
                        'div',
                        { id: 'noProductInStore', className: 'inline text-theme' },
                        productOutOfStock
                    );
                }
            } else if ((product.modifier_option_id === null || product.modifier_option_id === undefined) && storable && product.storage_strict && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
                return _react3.default.createElement(
                    'div',
                    { id: 'noProductInStore', className: 'inline text-theme' },
                    productOutOfStock
                );
            }
            var buyInCreditActive = null;
            var buyInCreditSumMonth = 0;
            var buyInCreditButtonName = lang['onlineShop.buyInCredit.service'];
            if (this.props.buyInCredit.is_credit === false) {
                buyInCreditButtonName = lang['settingsBuyInCreditForm.title.installment'];
            }
            if (this.props.buyInCreditActive && product.price * count <= 500000 && product.price * count >= 3000) {
                buyInCreditButtonName = lang['onlineShop.buyInCredit.button1'] + parseFloat(product.price * count / 19 || 0).toFixed(2) + ' ' + lang['onlineShop.buyInCredit.button2'];
                if (this.props.buyInCredit.is_credit === false) {
                    buyInCreditButtonName = lang['onlineShop.buyInCredit.installments.button1'] + parseFloat(product.price * count / 19 || 0).toFixed(2) + ' ' + lang['onlineShop.buyInCredit.button2'];
                }
                buyInCreditActive = _react3.default.createElement(
                    'button',
                    (0, _extends3.default)({
                        style: { width: '100%', paddingLeft: '5px', paddingRight: '5px' },
                        className: 'button_credit' }, props, {
                        onClick: function onClick(event) {
                            return callbackOneClick(event, true);
                        } }),
                    buyInCreditButtonName
                );
            }
            if (this.props.orderInOneClick && !this.props.buyInCreditActive) {
                return _react3.default.createElement(
                    'div',
                    { className: 'inline' },
                    customFieldsView,
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: { marginBottom: '10px', width: '90%' }, className: className.join(' ') }, props, { onClick: callback }),
                        addBasketButtonName
                    ),
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: { width: '90%' }, className: 'le-button' }, props, { onClick: callbackOneClick }),
                        addBasketButtonOneClickName
                    )
                );
            } else if (!this.props.orderInOneClick && this.props.buyInCreditActive) {
                var style = { marginBottom: '10px', width: '100%' };
                return _react3.default.createElement(
                    'div',
                    { className: 'inline' },
                    customFieldsView,
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: style, className: className.join(' ') }, props, { onClick: callback }),
                        addBasketButtonName
                    ),
                    buyInCreditActive
                );
            } else if (this.props.orderInOneClick && this.props.buyInCreditActive) {
                var _buyInCreditActive = null;
                if (this.props.buyInCreditActive && product.price * count <= 500000 && product.price * count >= 3000) {
                    _buyInCreditActive = _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({
                            style: { marginBottom: '10px', width: '90%', paddingLeft: '5px', paddingRight: '5px' },
                            className: 'button_credit' }, props, {
                            onClick: function onClick(event) {
                                return callbackOneClick(event, true);
                            } }),
                        buyInCreditButtonName
                    );
                }
                return _react3.default.createElement(
                    'div',
                    { className: 'inline', style: { textAlign: 'center' } },
                    customFieldsView,
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: { marginBottom: '10px', width: '100%' }, className: className.join(' ') }, props, { onClick: callback }),
                        addBasketButtonName
                    ),
                    _buyInCreditActive,
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: { width: '100%' }, className: 'le-button' }, props, { onClick: callbackOneClick }),
                        addBasketButtonOneClickName
                    )
                );
            } else {
                return _react3.default.createElement(
                    'div',
                    { className: 'inline', style: { textAlign: 'center' } },
                    customFieldsView,
                    _react3.default.createElement(
                        'button',
                        (0, _extends3.default)({ style: { width: '100%' }, className: className.join(' ') }, props, { onClick: callback }),
                        addBasketButtonName
                    )
                );
            }
        }
    }]);
    return AddToBasketView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object
}, _temp));

exports.default = AddToBasketView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/AddToBasket/default/AddToBasketView.jsx
// module id = 1611
// module chunks = 0